// Keeps the homepage hero videos playing on every device: muted, inline, no controls, and resumed whenever the browser pauses them.
class SHeroAutoplay extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const host = this.closest('[data-hero-media]');
    if (!host) return;
    const videos = [...host.querySelectorAll('video')];

    const prep = (v) => {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.autoplay = true;
      v.controls = false;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('disableremoteplayback', '');
      v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
      v.removeAttribute('controls');
      v.tabIndex = -1;
      v.setAttribute('aria-hidden', 'true');
    };
    const isShown = (v) => v.offsetParent !== null || v.getClientRects().length > 0;
    const play = (v) => {
      if (!isShown(v) || !v.paused || document.hidden) return;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };
    const playAll = () => videos.forEach(play);

    videos.forEach((v) => {
      prep(v);
      // Resume whenever anything pauses it (end of loop glitches, tab switches, browser power saving).
      v.addEventListener('pause', () => requestAnimationFrame(() => play(v)), opts);
      v.addEventListener('ended', () => { v.currentTime = 0; play(v); }, opts);
      v.addEventListener('canplay', () => play(v), opts);
      v.addEventListener('loadeddata', () => play(v), opts);
      v.addEventListener('contextmenu', (e) => e.preventDefault(), opts);
    });

    playAll();
    document.addEventListener('visibilitychange', playAll, opts);
    window.addEventListener('pageshow', playAll, opts);
    window.addEventListener('resize', playAll, opts);
    // Phones in Low Power Mode block autoplay until the shopper touches the page; start it on the first touch, scroll or click anywhere.
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((type) => {
      window.addEventListener(type, playAll, { ...opts, passive: true });
    });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-hero-autoplay')) customElements.define('s-hero-autoplay', SHeroAutoplay);
